module.exports = __webpack_public_path__ + "img/thanksgiving.80682a8e.png";